import { useQuery } from '@tanstack/react-query';
import { getLine, me } from '../api/portal';
import { ApiError } from '../api/client';

export function LinePage() {
  const profile = useQuery({ queryKey: ['portal-me'], queryFn: me });
  const feed = useQuery({ queryKey: ['portal-line'], queryFn: () => getLine(), refetchInterval: 12_000 });
  return (
    <div>
      <div className="page-head">
        <div className="page-kicker">Delivery</div>
        <h1 className="page-title">Origo Line</h1>
        <p className="page-sub">
          Pretplata na Wire dropove liga u tvojoj licenci. Jedna traka za redakciju.
          Plan: <span className="text-white">{feed.data?.plan || profile.data?.line_plan || '…'}</span>
        </p>
      </div>
      {feed.isError && <div className="alert-bad mb-3">{feed.error instanceof ApiError ? feed.error.message : String(feed.error)}</div>}
      <div className="card mb-4 p-4 text-[12px] text-slate-400">
        <div>GET http://127.0.0.1:8081/line/v1/feed?since= — Bearer client JWT</div>
        {feed.data?.plan === 'live' && <div>WS http://127.0.0.1:8081/line/v1/stream?access_token=…</div>}
      </div>
      <div className="card overflow-hidden">
        <table className="table">
          <thead>
            <tr><th>Drop</th><th>Liga</th><th>Kad</th></tr>
          </thead>
          <tbody>
            {(feed.data?.drops ?? []).map((d) => (
              <tr key={d.id}>
                <td>
                  <div className="text-white">{d.card?.copy?.press_lead || d.card?.copy?.telegram || d.kind}</div>
                  <div className="text-[11px] text-slate-500">{d.kind}{d.media_late ? ' · medij kasni' : ''}</div>
                </td>
                <td className="text-slate-300">{d.league || d.slug || '—'}</td>
                <td className="tabular-nums text-slate-500">{(d.created_at || '').replace('T', ' ').slice(0, 16)}</td>
              </tr>
            ))}
          </tbody>
        </table>
        {(feed.data?.drops ?? []).length === 0 && !feed.isError && (
          <div className="p-4 text-sm text-slate-500">Nema dropova. Liga mora imati Wire; ti Line plan feed ili live.</div>
        )}
      </div>
    </div>
  );
}
